import { Button } from "@/components/ui/button";
import { ShieldCheck, Trash2 } from "lucide-react";

export function MemberCard({ member, isViewerAdmin, onRemove, busy }) {
  const uid = String(member.userId);

  return (
    <div className="flex items-center justify-between gap-3 bg-card border border-border rounded-xl px-4 py-3">
      <div className="flex items-center gap-3 min-w-0">
        {member.isAdmin && <ShieldCheck size={14} className="text-primary shrink-0" />}
        <div className="min-w-0">
          <div className="text-sm font-medium text-foreground truncate">
            {member.name}
            {member.isAdmin && (
              <span className="ml-1.5 text-xs text-primary font-normal">Admin</span>
            )}
          </div>
          <div className="text-xs text-muted-foreground truncate">{member.email}</div>
        </div>
      </div>

      {isViewerAdmin && !member.isAdmin && (
        <Button
          variant="ghost" size="sm"
          className="h-7 w-7 p-0 text-muted-foreground hover:text-destructive hover:bg-destructive/10 shrink-0"
          title="Remove member" disabled={busy}
          onClick={() => onRemove(uid, member.name)}
        >
          <Trash2 size={13} />
        </Button>
      )}
    </div>
  );
}
